





























import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapMutations, mapActions } from 'vuex'

@Component({
  components: {},
  computed: {
    ...mapGetters('buildergpt', ['getCurrentStep', 'getConfirmedSteps', 'getAccessibleStep']),
  },
  methods: {
    ...mapMutations('buildergpt', ['changeStep', 'setData']),
    ...mapActions('buildergpt', ['step2Submit']),
  },
})
export default class StepsNavigation extends Vue {
  getCurrentStep!: number
  getAccessibleStep!: number
  getConfirmedSteps!: number[]
  changeStep!: (number) => void
  get stepsList() {
    return [
      {
        num: 1,
        label: this.$t('builderGpt.navigation.1'),
      },
      {
        num: 2,
        label: this.$t('builderGpt.navigation.2'),
      },
      {
        num: 3,
        label: this.$t('builderGpt.navigation.5'),
      },
      {
        num: 4,
        label: this.$t('builderGpt.navigation.3'),
      },
      {
        num: 5,
        label: this.$t('builderGpt.navigation.4'),
      },
      {
        num: 6,
        label: this.$t('builderGpt.navigation.6'),
      },
    ]
  }

  isChekedStep(step: number): boolean {
    return this.getConfirmedSteps.includes(step)
  }

  isStepShow(step: number): boolean {
    return step <= this.getAccessibleStep
  }
  goToStep(step: number): void {
    this.changeStep(step)
    this.$store.dispatch('app/changeVisibilityMenu', false)
    this.$router.push({ path: `/gpt/step/${this.getCurrentStep}` })
  }
}
